module.exports = __webpack_public_path__ + "static/media/8OLA12.e5ea29ef.jpg";